import { FC, useCallback, ReactNode } from "react";
import * as React from "react";
import * as ReactDOM from "react-dom";
import * as ReactDOMClient from "react-dom/client";
import * as ReactRouter from "react-router";
import * as ReactHookForm from "react-hook-form";
import { Shell, LibraryRegistrationFn, ShellSwitch } from "capitalrx-shell";
import * as ReactQuery from "@tanstack/react-query";
import { setAnalyticsUserId } from "./utils/analytics";
import { LegacyRoutes } from "./shell";
import * as LegacyPermissions from "./constants/permissions";
import * as CapitalRxComponents from "capitalrx-components";
import * as CapitalRxComponents2 from "capitalrx-components-2.0";
import * as CapitalRxUtilities from "capitalrx-utilities";
import * as Color from "capitalrx-components-2.0/lib/general/Color";

const queryClient = new ReactQuery.QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

/** The main application. */
const App: FC = () => {
  const initializeSharedLibrariesHandler = useCallback((register: LibraryRegistrationFn) => {

    const PatchedReactRouter = {
      ...ReactRouter,
      Switch: ShellSwitch,
    };

    register("react", React);
    register("react-dom", ReactDOM);
    register("react-dom/client", ReactDOMClient);
    register("react-router", PatchedReactRouter);
    register("@tanstack/react-query", ReactQuery);
    register("capitalrx-legacy-permissions", LegacyPermissions);
    register("capitalrx-components", CapitalRxComponents);
    register("capitalrx-components-2.0", CapitalRxComponents2);
    register("capitalrx-components-2.0/lib/typography", CapitalRxComponents2.Typography);
    register("capitalrx-components-2.0/lib/general", CapitalRxComponents2.General);
    register("capitalrx-components-2.0/lib/layout", CapitalRxComponents2.Layout);
    register("capitalrx-components-2.0/lib/forms", CapitalRxComponents2.Forms);
    register("capitalrx-components-2.0/lib/general/Color", Color);
    register("capitalrx-utilities", CapitalRxUtilities);
    register("react-hook-form", ReactHookForm);
  }, []);

  return (
    <ReactQuery.QueryClientProvider client={queryClient}>
      <Shell onAnalyticsIdChange={setAnalyticsUserId} onInitializeSharedLibraries={initializeSharedLibrariesHandler}>
        {(): ReactNode => <LegacyRoutes />}
      </Shell>
    </ReactQuery.QueryClientProvider>
  );
};

export default App;
